import React from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import {
    Badge, Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Drawer,
    IconButton,
    useMediaQuery
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ShoppingBag } from "lucide-react";
import { connect } from "trim-redux";
import { Link, useNavigate } from "react-router-dom";
import { theme } from "../../../../../config/design/theme";
import CartWidget from "../../../../pages/front/shops/components/CartWidget";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Grid from "@mui/material/Grid2";
import SubTitle from "../../../elements/SubTitle";

function HeaderCartIcon({ user, classes }) {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const navigation = useNavigate();
    const vendor_link = user?.cart_shop?.slug;
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    const currentUrl = decodeURIComponent(window.location.pathname);
    const showCartButton = isMobile && currentUrl === `/vendor/${vendor_link}`;

    const handleClick = () => {
        if(!!vendor_link){
            navigation(`/vendor/${vendor_link}`)
        }
        if(isMobile){
            setOpen(true)
        }
    };

    return (
        <>
            <Badge badgeContent={user?.carts_count} color="secondary" className="header-cart-badge">
                <IconButton onClick={handleClick}>
                    <ShoppingBag className="lucide-icon-text" />
                </IconButton>
            </Badge>

            <Drawer
                anchor={"bottom"}
                open={open}
                onClose={() => setOpen(false)}
                className="filter-categories-drawer"
            >
                <Grid container spacing={2}>
                    <Grid item size={12} style={{ position: "relative" }}>
                        <SubTitle align="left" className="filter-subtitle">{t('yourItems')}</SubTitle>
                        <IconButton
                            onClick={() => setOpen(false)}
                            size="small"
                            className={classes.drawerClose}
                        >
                            <CloseRoundedIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                    <Grid item size={12}>
                        <CartWidget dialog closeDialog={() => setOpen(false)}/>
                    </Grid>
                </Grid>
            </Drawer>

            {showCartButton && !open && !!user?.carts_count && (
                <Button
                    className="cart-floating-btn"
                    variant="contained"
                    startIcon={<ShoppingBag />}
                    endIcon={`(${user?.carts_count})`}
                    onClick={handleClick}
                >
                    {t('viewCart')}
                </Button>
            )}
        </>
    );
}

const mstp = state => ({
    user: state.user,
    isAuth: state.isAuth,
});
export default withStyles(Styles)(connect(mstp)(HeaderCartIcon));
